export default __webpack_public_path__ + "static/media/elbwalker_logo_centred_blue_white.55f5e586.svg";